import { render } from "./quickEntry.vue?vue&type=template&id=ddaa05b4"
import script from "./quickEntry.vue?vue&type=script&lang=ts"
export * from "./quickEntry.vue?vue&type=script&lang=ts"
script.render = render

export default script